import React, { Fragment } from 'react';
import moment from 'moment';

export const DateFormat = ({ date }) => <Fragment> {moment(date).format('LLL')} </Fragment>;
export const Format = ({ amount }) => (
  <Fragment>{typeof amount === 'number' ? amount.toFixed(2) : amount}</Fragment>
);
